import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { userData } from "../data/userData";
import {
  aboutMeRoute,
  contactRoute,
  homeRoute,
  mobileRoute,webRoute,
  otherProjectsRoute,
  productDesignsRoute,
  macrosRoute,
} from "../constants/routeConstants";

export const LeftMenu = () => {
  const location = useLocation();

  const activeClass = "py-5 text-right hover:text-red-500";
  const deactClass = "py-5 text-right  text-red-500";
  const textStyle = (str: string) =>
    location.pathname.includes(str) ? deactClass : activeClass;

  return (
    <nav className="hidden sm:flex flex-col w-56">
      <NavLink to={homeRoute}>
        <div className="inline-flex flex-col text-white mb-12 text-right hover:text-gray-300 cursor-pointer">
          <span className="text-2xl ">{userData.name}</span>
          <span className="text-sm italic">{userData.title}</span>
        </div>
      </NavLink>
      <div className="text-white text-xl navbar cursor-pointer inline-flex flex-col">
        <NavLink to={aboutMeRoute} className={textStyle(aboutMeRoute)}>
          About Me
        </NavLink>

        <NavLink
          to={macrosRoute}
          className={textStyle(macrosRoute)}
        >
          {"Macros & GUIs"}
        </NavLink>

        <NavLink
          to={mobileRoute}
          className={textStyle(mobileRoute)}
        >
          {"Mobile  Projects"}
        </NavLink>

        <NavLink
          to={webRoute}
          className={textStyle(webRoute)}
        >
          {"Web Projects"}
        </NavLink>

        <NavLink
          to={productDesignsRoute}
          className={textStyle(productDesignsRoute)}
        >
          {`Product & Mechanical Designs`}
        </NavLink>

        <NavLink
          to={otherProjectsRoute}
          className={textStyle(otherProjectsRoute)}
        >
          Other Projects
        </NavLink>

        <NavLink to={contactRoute} className={textStyle(contactRoute)}>
          Contact
        </NavLink>
      </div>
      <div className="inline-flex flex-row gap-5 mt-12 justify-end">
        <a
          className="text-white text-3xl hover:text-yellow-500 "
          rel="noopener noreferrer"
          href={userData.github}
          target="_blank"
        >
          <FontAwesomeIcon icon={faGithub} />
        </a>

     {userData.linkedin &&   <a
          className="text-white text-3xl hover:text-blue-500 "
          rel="noopener noreferrer"
          href={userData.linkedin}
          target="_blank"
        >
          <FontAwesomeIcon icon={faLinkedin} />
        </a>}
        <a
          className="text-white text-3xl hover:text-yellow-500 "
          rel="noopener noreferrer"
          href={`mailto: ${userData.email}`}
          target="_blank"
        >
          <FontAwesomeIcon icon={faEnvelope} />
        </a>
      </div>
    </nav>
  );
};
